export const currencyFormat = (rs: number, currency = "INR") => {
  if (!rs) rs = 0;
  if (!isNaN(rs)) rs = Number(rs);
  return rs.toLocaleString("en-IN", {
    maximumFractionDigits: 3,
    minimumFractionDigits: 0,
    style: "currency",
    currency,
  });
};

export const isValidCurrencyCode = (code: string) => {
  const validCurrencies = [
    "USD",
    "EUR",
    "INR",
    "GBP",
    "JPY",
    "AUD",
    "CAD",
    "CHF",
    "CNY",
    "SEK",
    "NZD",
  ]; // Extend as needed
  return validCurrencies.includes(code);
};

// export const currencyFormat = (rs: number, currency = "INR") => {
//   if (!rs) rs = 0;
//   if (!isNaN(rs)) rs = Number(rs);
//   const validatedCurrency = isValidCurrencyCode(currency) ? currency : "INR";
//   return rs.toLocaleString("en-IN", {
//     maximumFractionDigits: 2,
//     minimumFractionDigits: 0,
//     style: "currency",
//     currency: validatedCurrency,
//   });
// };
